// @flow
import type {
  BaseCardsType,
  BlokComponentPropsType,
  BlokComponentType,
  LargeCardImageType
} from 'components/types';
import renderComponent from 'components/editable/renderComponent';
import { interpolate } from 'react-spring/web.cjs';
import Template from '../Template';
import Carousel from '../Carousel';
import {
  LargeImageCard,
  StaticLargeImageCard,
  LargeImagesGrid
} from './static';
import { AnimatedLargeImageCard, CARD_DISPLAYS } from './carousel';
import * as componentKeys from '../../../../componentKeys';

const componentMap = {
  [componentKeys.CARD_LARGE_IMAGE]: StaticLargeImageCard
};

const animatedComponentMap = {
  [componentKeys.CARD_LARGE_IMAGE]: LargeImageCard
};

const renderComponentCustomPath =
  'components/editable/Cards/LargeCardImage/index.jsx';
function springsRenderer(
  springs: *[],
  cards: BlokComponentType<LargeCardImageType>[]
): any {
  return springs.map((styles, index) =>
    renderComponent(
      cards[index],
      {
        key: cards[index]._uid + index,
        customPath: renderComponentCustomPath,
        style: {
          ...styles,
          transform: interpolate(
            [styles.translateX, styles.opacity],
            (translateXVal) => `translate(${translateXVal}px, -50%)`
          )
        },
        component: AnimatedLargeImageCard,
        onDragStart: (event) => {
          // This prevents the default "drag" effect of links in Safari
          event.preventDefault();
          return false;
        }
      },
      animatedComponentMap
    )
  );
}

const LargeImageCards = ({
  blok
}: BlokComponentPropsType<{
  ...BaseCardsType,
  cards: BlokComponentType<LargeCardImageType>[]
}>) => {
  const {
    title,
    sub_title: subTitle,
    description,
    cards,
    call_to_action: callToAction,
    call_to_action_text: callToActionText,
    use_carousel: useCarousel
  } = blok;
  let children;
  if (useCarousel) {
    children = (
      <Carousel
        cards={cards}
        title={title}
        cardDisplays={CARD_DISPLAYS}
        springsRenderer={springsRenderer}
      />
    );
  } else {
    children = (
      <LargeImagesGrid>
        {cards.map((card, index) =>
          renderComponent(
            card,
            {
              customPath: renderComponentCustomPath,
              key: card._uid + index
            },
            componentMap
          )
        )}
      </LargeImagesGrid>
    );
  }
  return (
    <Template
      callToAction={callToAction}
      callToActionText={callToActionText}
      description={description}
      subTitle={subTitle}
      title={title}
      useCarousel={useCarousel}
    >
      {children}
    </Template>
  );
};

export default LargeImageCards;
